import { DocumentListView } from '@/components/documents/DocumentListView'

export default function OrdersPage() {
  return <DocumentListView kind="order" />
}
